"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var style_to_object_1 = __importDefault(require("style-to-object"));

var utilities_1 = require("./utilities");

function StyleToJS(style, options) {
  var output = {};

  if (!style || typeof style !== 'string') {
    return output;
  }

  style_to_object_1["default"](style, function (property, value) {
    if (property && value) {
      output[utilities_1.camelCase(property, options)] = value;
    }
  });
  return output;
}

exports["default"] = StyleToJS;